//
// Main
//
function memoize$2(fn, options) {
  var cache = options && options.cache ? options.cache : cacheDefault$2;
  var serializer = options && options.serializer ? options.serializer : serializerDefault$2;
  var strategy = options && options.strategy ? options.strategy : strategyDefault$2;
  return strategy(fn, {
    cache: cache,
    serializer: serializer
  });
}
//
// Strategy
//
function isPrimitive$2(value) {
  return value == null || typeof value === 'number' || typeof value === 'boolean'; // || typeof value === "string" 'unsafe' primitive for our needs
}
function monadic$2(fn, cache, serializer, arg) {
  var cacheKey = isPrimitive$2(arg) ? arg : serializer(arg);
  var computedValue = cache.get(cacheKey);
  if (typeof computedValue === 'undefined') {
    computedValue = fn.call(this, arg);
    cache.set(cacheKey, computedValue);
  }
  return computedValue;
}
function variadic$2(fn, cache, serializer) {
  var args = Array.prototype.slice.call(arguments, 3);
  var cacheKey = serializer(args);
  var computedValue = cache.get(cacheKey);
  if (typeof computedValue === 'undefined') {
    computedValue = fn.apply(this, args);
    cache.set(cacheKey, computedValue);
  }
  return computedValue;
}
function assemble$2(fn, context, strategy, cache, serialize) {
  return strategy.bind(context, fn, cache, serialize);
}
function strategyDefault$2(fn, options) {
  var strategy = fn.length === 1 ? monadic$2 : variadic$2;
  return assemble$2(fn, this, strategy, options.cache.create(), options.serializer);
}
function strategyVariadic$2(fn, options) {
  return assemble$2(fn, this, variadic$2, options.cache.create(), options.serializer);
}
//
// Serializer
//
var serializerDefault$2 = function () {
  return JSON.stringify(arguments);
};
//
// Cache
//
function ObjectWithoutPrototypeCache$2() {
  this.cache = Object.create(null);
}
ObjectWithoutPrototypeCache$2.prototype.get = function (key) {
  return this.cache[key];
};
ObjectWithoutPrototypeCache$2.prototype.set = function (key, value) {
  this.cache[key] = value;
};
var cacheDefault$2 = {
  create: function create() {
    // @ts-ignore
    return new ObjectWithoutPrototypeCache$2();
  }
};
var strategies$2 = {
  variadic: strategyVariadic$2
};

//
// Main
//
function memoize$1(fn, options) {
  var cache = options && options.cache ? options.cache : cacheDefault$1;
  var serializer = options && options.serializer ? options.serializer : serializerDefault$1;
  var strategy = options && options.strategy ? options.strategy : strategyDefault$1;
  return strategy(fn, {
    cache: cache,
    serializer: serializer
  });
}
//
// Strategy
//
function isPrimitive$1(value) {
  return value == null || typeof value === 'number' || typeof value === 'boolean'; // || typeof value === "string" 'unsafe' primitive for our needs
}
function monadic$1(fn, cache, serializer, arg) {
  var cacheKey = isPrimitive$1(arg) ? arg : serializer(arg);
  var computedValue = cache.get(cacheKey);
  if (typeof computedValue === 'undefined') {
    computedValue = fn.call(this, arg);
    cache.set(cacheKey, computedValue);
  }
  return computedValue;
}
function variadic$1(fn, cache, serializer) {
  var args = Array.prototype.slice.call(arguments, 3);
  var cacheKey = serializer(args);
  var computedValue = cache.get(cacheKey);
  if (typeof computedValue === 'undefined') {
    computedValue = fn.apply(this, args);
    cache.set(cacheKey, computedValue);
  }
  return computedValue;
}
function assemble$1(fn, context, strategy, cache, serialize) {
  return strategy.bind(context, fn, cache, serialize);
}
function strategyDefault$1(fn, options) {
  var strategy = fn.length === 1 ? monadic$1 : variadic$1;
  return assemble$1(fn, this, strategy, options.cache.create(), options.serializer);
}
function strategyVariadic$1(fn, options) {
  return assemble$1(fn, this, variadic$1, options.cache.create(), options.serializer);
}
//
// Serializer
//
var serializerDefault$1 = function () {
  return JSON.stringify(arguments);
};
//
// Cache
//
function ObjectWithoutPrototypeCache$1() {
  this.cache = Object.create(null);
}
ObjectWithoutPrototypeCache$1.prototype.get = function (key) {
  return this.cache[key];
};
ObjectWithoutPrototypeCache$1.prototype.set = function (key, value) {
  this.cache[key] = value;
};
var cacheDefault$1 = {
  create: function create() {
    // @ts-ignore
    return new ObjectWithoutPrototypeCache$1();
  }
};
var strategies$1 = {
  variadic: strategyVariadic$1
};

//
// Main
//
function memoize(fn, options) {
  var cache = options && options.cache ? options.cache : cacheDefault;
  var serializer = options && options.serializer ? options.serializer : serializerDefault;
  var strategy = options && options.strategy ? options.strategy : strategyDefault;
  return strategy(fn, {
    cache: cache,
    serializer: serializer
  });
}
//
// Strategy
//
function isPrimitive(value) {
  return value == null || typeof value === 'number' || typeof value === 'boolean'; // || typeof value === "string" 'unsafe' primitive for our needs
}
function monadic(fn, cache, serializer, arg) {
  var cacheKey = isPrimitive(arg) ? arg : serializer(arg);
  var computedValue = cache.get(cacheKey);
  if (typeof computedValue === 'undefined') {
    computedValue = fn.call(this, arg);
    cache.set(cacheKey, computedValue);
  }
  return computedValue;
}
function variadic(fn, cache, serializer) {
  var args = Array.prototype.slice.call(arguments, 3);
  var cacheKey = serializer(args);
  var computedValue = cache.get(cacheKey);
  if (typeof computedValue === 'undefined') {
    computedValue = fn.apply(this, args);
    cache.set(cacheKey, computedValue);
  }
  return computedValue;
}
function assemble(fn, context, strategy, cache, serialize) {
  return strategy.bind(context, fn, cache, serialize);
}
function strategyDefault(fn, options) {
  var strategy = fn.length === 1 ? monadic : variadic;
  return assemble(fn, this, strategy, options.cache.create(), options.serializer);
}
function strategyVariadic(fn, options) {
  return assemble(fn, this, variadic, options.cache.create(), options.serializer);
}
//
// Serializer
//
var serializerDefault = function () {
  return JSON.stringify(arguments);
};
//
// Cache
//
function ObjectWithoutPrototypeCache() {
  this.cache = Object.create(null);
}
ObjectWithoutPrototypeCache.prototype.get = function (key) {
  return this.cache[key];
};
ObjectWithoutPrototypeCache.prototype.set = function (key, value) {
  this.cache[key] = value;
};
var cacheDefault = {
  create: function create() {
    // @ts-ignore
    return new ObjectWithoutPrototypeCache();
  }
};
var strategies = {
  variadic: strategyVariadic
};

export { memoize as a, strategies$2 as b, memoize$1 as c, strategies$1 as d, memoize$2 as m, strategies as s };
//# sourceMappingURL=index-B7cuny9n-CPavUJbF.js.map
